import { StateKey } from 'common/utils/flipState'
import { CommonState } from 'common/types'

export const MIN_MAP_TRANSLATE_Y = -151
export const ZOOM_DEFAULT = 10

export interface MapState {
  center: {
    lat: number
    lng: number
  }
  zoom: number
  translateY: number
}

const initialState: MapState = {
  center: {
    lat: 0,
    lng: 0,
  },
  zoom: 0,
  translateY: 0,
}

const INIT = 'map/state/INIT'
const SET = 'map/state/SET'
const SET_TRANSLATE_Y = 'map/state/SET_TRANSLATE_Y'

export const initMapState = (curState: StateKey) => {
  return {
    curState,
    type: INIT,
  }
}

export const setMapState = (curState: StateKey, mapState: MapState) => {
  return {
    curState,
    mapState,
    type: SET,
  }
}

export const setMapTranslateY = (curState: StateKey, translateY: number) => (dispatch, getState: () => CommonState) => {
  const mapState = getState().mapState[curState]
  if (mapState.translateY === translateY) return
  dispatch({
    curState,
    translateY,
    type: SET_TRANSLATE_Y,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT:
      return initialState
    case SET:
      return action.mapState
    case SET_TRANSLATE_Y:
      return {
        ...state,
        translateY: action.translateY,
      }
    default:
      return state
  }
}

export default reducer
